import {useEffect, useState } from "react"
import PropTypes from "prop-types";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import { useSelector, useDispatch } from "react-redux";
import { withRouter } from "react-router-dom";
import styles from "./style.module.scss";
import LeftSideComponent from "./leftSideComponent";
import SearchComponent from "./searchComponent";
import MainComponent from "./mainComponent"
import { makeStyles } from "@material-ui/core/styles";
import connectionActions from "../../redux/connections/actions"

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
  text: {
    top: "50px",
    position: "relative",
    left: "-50px",
  },
  cover: {
    width: 73,
    height: 73,
    borderRadius: "50%",
  },
}));

const Profile = ({ history }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const {
    loading,
    currentUser,
    pending = [],
    allUsers = [],
    filters = {},
    pendingConnections = []
  } = useSelector((state) => ({
    loading: state.connection.loading,
    currentUser: state.profile.currentUser,
    allUsers: state.connection.allUsers,
    pending: state.creditz.creditz,
    filters: state.connection.filters,
    pendingConnections: state.connection.pendingConnections
  }));

  const [list, setList] = useState([]);

  useEffect(()=>{
    dispatch({
      type: connectionActions.FIND_ALL
    })
  }, [])

  useEffect(() => {
    makeSearch()
    const locationset = new Set();
    allUsers.map((user) => {
      locationset.add(user.location);
    });
    const locations = [];
    for (const item of locationset) locations.push(item);
    dispatch({
      type: connectionActions.SET_STATE,
      payload: { locations },
    });
  }, [allUsers]);

  const makeSearch = () => {
    const l = allUsers.filter((user) => {
      return (
        (user.genre?.toLowerCase()?.includes(filters.genre) &&
        user.location?.toLowerCase().includes(filters.location)) ||
        user.role?.toLowerCase()?.includes(filters.role)
      );
    });
    setList(l);
  }

  return (
    <>
      <Backdrop className={classes.backdrop} open={loading}>
        <CircularProgress style={{ width: 30, height: 30 }} color="inherit" />
      </Backdrop>
      <div className={styles.mainComponent}>
        <div className={styles.mainContent}>
          <div className={styles.leftContainer}>
            <LeftSideComponent
              currentUser={currentUser}
              pending={
                pending.filter((c) => c.notification.status === 1).length
              }
              pendingConnections={pendingConnections.length}
            />
          </div>
          <div className={styles.rightContainer}>
            <MainComponent list={list} />
          </div>
          <div className={styles.searchContainer}>
            <SearchComponent makeSearch={makeSearch} />
          </div>
        </div>
      </div>
    </>
  );
};

Profile.propTypes = {
  history: PropTypes.object,
};

export default withRouter(Profile);
